function getItemName(item: Record<string, any>): string {
  const firstKey = Object.keys(item)[0] || "";
  return firstKey === "cde"
    ? "CDE"
    : firstKey.charAt(0).toUpperCase() + firstKey.slice(1);
}

export default getItemName;
